/* eslint-disable @stylistic/comma-dangle */

import { messages as commonLocale }	from "@geotoura/common/locale_en";
import { sharedLocale }				from "@geotoura/shared/sharedLocale_en";
import { siteInfo }					from "@geotoura/shared/siteInfo_en";

export const messages = {
	app: {
		title:		"Quick start",
		inquiry1:	"Request",
		inquiry2:	"offer",
		planner1:	"Plan",
		planner2:	"individually",
		meeting1:	"Consult",
		meeting2:	"personally"
	},
	form: commonLocale.form,
	inquiry: {
		introGeneral:	"Please send me a free and non-binding travel offer.",
		introRoute:		"Please send me a free and non-binding offer for the route",
		date: {
			label:			"Travel date",
			placeholder:	"When do you want to travel?",
		},
		notes: {
			label:			"My wishes",
			placeholder:	"There is space here for your wishes: places you would like to visit, special requirements, etc.",
		},
		submitLabel:	"Send offer"
	},
	meeting: {
		intro:	"Arrange a personal travel consultation (Monday to Friday from 9.30 a.m. to 6 p.m.)",
		or:		"or",
		booking: {
			href:	"https://outlook.office.com/book/GeotouraTravel@geotoura.com/s/-ZQEcEG-PEq5xr5hTNWcpQ2?ismsaljsauthenabled",
			text:	"Schedule a consultation",
		},
		notes: {
			label:			"Date and wishes",
			placeholder:	"Please let us know your preferred date and the topic (destination, type of trip …) you are interested in",
		},
		contactWay: {
			label:	"How would you prefer to speak to us?",
			email:	"E-mail",
			phone:	"Telephone",
			video:	"Video conference"
		},
		submitLabelOld:	"Arrange a consultation",
		submitLabelNew:	"Consult via email",
	},
	planner: {
		text1:			"Use our holiday planner! Design your dream holiday according to your own personal ideas.",
		text2:			"On an interactive map, you can easily put together travel destinations, overnight stays and extras.",
		text3:			"A holiday couldn't be more individual!",
		textmobile1:	"Design your dream holiday according to your own personal ideas.",
		textmobile2:	"On an interactive map, you can easily put together travel destinations, overnight stays and extras.",
		linkLabel:		"Start your holiday planner now",
		wordpressBase:	siteInfo.wordpressBase,
		imgAlt:			"Screenshot of a route planner. It shows a map section on which travel destinations are marked with yellow and green markers. Some of them are connected to a route with a red line. Next to it is a view with a photo (sea and palm trees), text about the selected location (Costa de Sol West), hotels and a toolbar with buttons.",
	},
	util: {
		success:{
			title:	"Your message has been sent",
			text:	"Thank you for your enquiry. We will reply as soon as possible."
		},
		error: {
			title:	"An error has occurred",
			text1:	"Sorry, your message could not be sent. Please try again later, contact us by e-mail at",
			mail:	sharedLocale.email.info,
			text2:	"or simply give us a call at",
			tel:	sharedLocale.phone,
		},
		signature:	"Your Geotoura team",
		close:		"Close",
	}
};
